import { ClusteredMarkerLayer } from '../Layers/ClusteredMarkersLayer';
import { FilterLayer } from '../Layers/FilterLayer';
import type { FilterLayerOptions } from '../Layers/Layers.types';

export const bikeFilterPlanned = function (layers: ClusteredMarkerLayer[], options?: FilterLayerOptions): FilterLayer {
    const defaultOptions: FilterLayerOptions = {
        filterFn: (filteredFeatures, allFeatures) => {
            return allFeatures.filter((feature) => {
                const props = feature.properties;
                return filteredFeatures.includes(feature) || props.isFuture;
            });
        },
    };

    return new FilterLayer('bike-filter-planned', layers, { ...defaultOptions, ...options });
};
